import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { role, roleid, token } from "../Actions/AuthAction";
import {
  applyOnDrive,
  getdriveDetails,
  getListInstitutionJobApproval,
} from "../Actions/DriveAction";
import Shimmer from "../Common/Shimmer";
import { Add } from "./Add";
import FormApproval from "./FormApproval";
import InstitutionApprovalMessage from "../Drives/InstitutionApprovalMessage";
import { DriveApplyCandidateList } from "../Candidate/DriveApplyCandidateList";
import Swal from "sweetalert2";
import { Link, useHistory } from "react-router-dom";
import CONFIG from "../../config";

export const DriveDetails = () => {
  const [driveDetails, setdriveDetails] = useState(null);
  const driveid = useParams().driveid;
  const [showVenue, setshowVenue] = useState(false);
  const [showSelectionProcess, setshowSelectionProcess] = useState(true);
  const [edit, setedit] = useState(false);
  const userrole = role();
  const userroleid = roleid();

  const [jobID, setjobID] = useState(null);
  const [employerID, setemployerID] = useState(null);
  const [message, setmessage] = useState(null);
  const [candidate, setCandidate] = useState(null);
  const [jobIdtoSend, setjobIdtoSend] = useState([]);
  const history = useHistory();
  const [type, setType] = useState(1);

  useEffect(() => {
    window.scroll(0, 0);
    getData();
  }, []);

  const getmsg = () => {
    getListInstitutionJobApproval({
      key: token(),
      page: "-1",
      driveid: driveid,
    }).then((res) => {
      if (res.status) {
        setmessage(res.data);
      }
    });
  };
  const getData = () => {
    getmsg();
    getdriveDetails({ loginusertoken: token(), driveid: driveid }).then(
      (res) => {
        if (res.error) {
          alert(res.error);
        } else {
          let newData = [];
          setdriveDetails(res.data[0]);
          if (res.data[0].candidatedrivemaps && userroleid != "5")
            res.data[0].candidatedrivemaps.map((item) => {
              item.candidate.job_id = item.job_id;
              item.candidate.employer_id = item.employer_id;
              newData.push(item.candidate);
            });
          if (roleid() == 3 || roleid() == 4) {
            setCandidate(newData);
          } else {
            setCandidate(res.data[0].candidates);
          }
        }
      }
    );
  };
  const handleApply = () => {
    if (jobIdtoSend.length == 0) {
      Swal.fire("Please Select at Least one Job", "", "error");
    } else {
      Swal.fire({
        title: "Are you sure you want to apply?",
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonText: "Yes",
        denyButtonText: `Don't save`,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          applyOnDrive({
            loginusertoken: token(),
            driveid: driveid,
            jobId: jobIdtoSend,
          }).then((res) => {
            if (res.error) {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: res.message,
              });
            } else {
              if (res.status) {
                Swal.fire({
                  title: "Your Application has been Submited.",
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: "Ok",
                }).then((respo) => history.push("/applieddrivelist"));
              }
            }
          });
        } else if (result.isDenied) {
          Swal.fire("Changes are not saved", "", "info");
        }
      });
    }
  };
  return (
    <React.Fragment>
      {edit ? (
        <Add edit={edit} driveDetails={driveDetails} />
      ) : (
        <div>
          <div className="row mb-4">
            <div className="col-md-12">
              <h4 className="table_heading position-relative">Drive Details</h4>
            </div>
          </div>

          {driveDetails ? (
            <div className="card formcard">
              <div className="card-body drive-details">
                <div
                  width="70%"
                  valign="top"
                  className="d-flex justify-content-between mb-3"
                >
                  <div className="d-flex justify-content-start">
                    {/* <img
                      src="https://admin.rozgar.com/upload/Test Employer1635837226.png"
                      className="company_logo"
                    /> */}
                    <h4 className="m-1 driveheading">
                      {driveDetails.drivename}
                    </h4>
                  </div>
                  <div>
                    <Link
                      className="btn btn-secondary-custom pull-right mr-3 mb-2"
                      to="/drivelist"
                    >
                      <i class="fas fa-arrow-left"></i> Back
                    </Link>
                    {/* {userrole == "Recruiter" ? <button onClick={() => setedit(!edit)}><i className="fas fa-edit" /></button> : null} */}
                    {/*{userrole == "Candidate" &&
                    driveDetails.candidatedrivemaps &&
                    driveDetails.candidatedrivemaps[0].status == 1 ? (
                      <span
                        className="btn btn-secondary rounded-pill pull-right mb-2"
                        
                      >
                        Applied
                      </span>
                    ) : null}
                    {userrole == "Candidate" &&
                    driveDetails.candidatedrivemaps &&
                    driveDetails.candidatedrivemaps[0].status == 2 ? (
                      <span
                        className="btn btn-secondary rounded-pill pull-right mb-2"
                        
                      >
                        Selected
                      </span>
                    ) : null}*/}
                  </div>
                </div>
                <div className="card-header1">Basic Details</div>
                <table
                  width="100%"
                  cellSpacing="0"
                  cellPadding="0"
                  border="0"
                  className="mt-4"
                >
                  <tr>
                    <td width="30%" valign="top">
                      <span> Drive ID </span>
                    </td>
                    <td width="70%" valign="top">
                      #{driveDetails.driveid}
                      {driveDetails.drivestatus == 2 ? (
                        <span className="badge badge-pill badge-success mx-1 ml-5 p-2 my-1">
                          Open
                        </span>
                      ) : (
                        <span className="badge badge-pill badge-danger mx-1 ml-5 p-2 my-1">
                          Closed
                        </span>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td width="30%" valign="top">
                      <span> Drive Type </span>
                    </td>
                    <td width="70%" valign="top">
                      {driveDetails.drivetype ? <>Pool</> : <>Single</>}
                    </td>
                  </tr>
                  <tr>
                    <td width="30%" valign="top">
                      <span> Map Institutes </span>
                    </td>
                    <td width="70%" valign="top">
                      <p>
                        {driveDetails.jobdriveinstmaps.map((item) => (
                          <span className="badge badge-pill badge-info mx-1 p-2">
                            {/* <img src={item.institute.logo} className="institute_logo" /> */}
                            {item.institute.name}
                          </span>
                        ))}
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td width="30%" valign="top">
                      <span> Drive Start Date and Time </span>
                    </td>
                    <td width="70%" valign="top">
                      {driveDetails.drivestartdate}
                    </td>
                  </tr>
                  <tr>
                    <td width="30%" valign="top">
                      <span> Drive End Date and Time </span>
                    </td>
                    <td width="70%" valign="top">
                      {driveDetails.driveenddate}
                    </td>
                  </tr>
                  <tr>
                    <td width="30%" valign="top">
                      <span> Last Date to Apply</span>
                    </td>
                    <td width="70%" valign="top">
                      {driveDetails.lastdateofapply}
                    </td>
                  </tr>
                  <tr>
                    <td width="30%" valign="top">
                      <span> Expected Joining Date </span>
                    </td>
                    <td width="70%" valign="top">
                      {driveDetails.expectedjoindate}
                    </td>
                  </tr>

                  <tr>
                    <td width="30%" valign="top">
                      <span> Location Type </span>
                    </td>
                    <td width="70%" valign="top">
                      Single
                    </td>
                  </tr>
                  <tr>
                    <td width="30%" valign="top">
                      <span> Venue </span>
                    </td>
                    <td width="70%" valign="top">
                      <div
                        dangerouslySetInnerHTML={{ __html: driveDetails.venue }}
                      />
                    </td>
                  </tr>
                </table>
                <div>
                  <div>
                    <h4
                      className="table_heading position-relative cursorEvent border-bottom pb-3"
                      onClick={(e) =>
                        setshowSelectionProcess(!showSelectionProcess)
                      }
                    >
                      Selection Process
                      <span className="float-right">
                        <i className="fas fa-arrow-down"></i>
                      </span>
                    </h4>
                  </div>
                  <div>
                    <div className="p-3 my-3">
                      <div
                        className={
                          showSelectionProcess ? "process-details" : "d-none"
                        }
                        dangerouslySetInnerHTML={{
                          __html: driveDetails.selectionprocess,
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div className="mt-3">
                  <div className="card-header1">Job List</div>
                </div>
                <div className="row">
                  {driveDetails.jobdrivejobmaps.length != 0 &&
                    driveDetails.jobdrivejobmaps.map((item, key) => (
                      <div key={key} className="col-md-4">
                        <div className=" jod-details-card">
                          <div className="user-info">
                            <div className="user-title jobbanner p-2 rounded-top border-bottom">
                              <div className="row">
                                <div className="col-md-2">
                                  <img
                                    className="company_logo"
                                    src={`${CONFIG.IMAGE_URL}/${item.job.employee.logo}`}
                                  />
                                </div>
                                <div className="col-md-10">
                                  <Link
                                    className="job-drive-summary font-weight-bold"
                                    to={`/jobdetail/${item.job.jobid}`}
                                  >
                                    {" "}
                                    {item.job.jobdesignation}
                                  </Link>
                                  <p className="companyname">
                                    {item.job.employee.companyname}
                                  </p>
                                </div>
                              </div>
                            </div>

                            {driveDetails.candidatedrivemaps &&
                              driveDetails.candidatedrivemaps.length != 0 &&
                              driveDetails.candidatedrivemaps.map(
                                (itemvalue) => {
                                  if (itemvalue.job_id == item.job.jobid) {
                                    item.job.applied = true;
                                  }
                                }
                              )}
                            {userroleid == "5" &&
                              (item.job.applied ? (
                                <span className="float-right bg-white py-1 px-2 rounded text-success">
                                  <i className="fa fa-check"></i>Applied
                                </span>
                              ) : (
                                <input
                                  className="joblistcheckbox"
                                  type="checkbox"
                                  onClick={(e) => {
                                    if (e.target.checked) {
                                      const result = jobIdtoSend;
                                      result.push({
                                        jobId: item.jobid,
                                        employerID: item.job.employee.id,
                                      });
                                      setjobIdtoSend(result);
                                    } else {
                                      const result = jobIdtoSend.filter(
                                        (item2) => item2.jobId != item.jobid
                                      );
                                      setjobIdtoSend(result);
                                    }
                                  }}
                                ></input>
                              ))}
                          </div>
                          <div class="py-2">
                            <p>
                              Job ID: <span>#{item.job.jobid} </span>
                            </p>
                            <p>
                              Salary:
                              <span>
                                {" "}
                                ₹{item.job.costtocompanystart.toLocaleString()}-
                                {item.job.costtocompanyend.toLocaleString()} LPA
                              </span>
                            </p>
                            <p>
                              Job Type:<span>{item.job.jobtype}</span>
                            </p>
                            <p>
                              Location:{" "}
                              {item.job.joblocationmaps.map((items) => (
                                <span className="location-job px-2 py-1">
                                  {items.city.name}
                                </span>
                              ))}
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
                <div class="d-flex justify-content-center">
                  {userroleid == "5" && (
                    <button
                      className="btn btn-primary-custom mt-3"
                      onClick={handleApply}
                    >
                      Apply
                    </button>
                  )}
                </div>
              </div>

              {roleid() == 2 || roleid() == 3 || roleid() == 1 ? (
                <InstitutionApprovalMessage
                  getmsg={getmsg}
                  message={message}
                  driveid={driveid}
                  institutionslist={driveDetails.jobdriveinstmaps}
                />
              ) : null}

              {roleid() == 2 || roleid() == 1 ? (
                message &&
                (message.length == 0 ||
                  message[message.length - 1].status != 2) ? (
                  <FormApproval getmsg={getmsg} driveid={driveid} />
                ) : (
                  <span></span>
                )
              ) : (
                <span></span>
              )}
              {roleid() != 5 ? (
                <DriveApplyCandidateList
                  heading={"CANDIDATE APPLIED LIST"}
                  type={"1"}
                  driveid={driveid}
                  candidateList={candidate}
                  getData={getData}
                />
              ) : null}
            </div>
          ) : (
            <Shimmer />
          )}
        </div>
      )}
    </React.Fragment>
  );
};
